<template>
  <section class="">
    <agent-sign-up-modal
      :agentAccount="agentDetails"
      :editAgentDetailsForm="true"
      :passwrd="false"
      :show="disableFormFields"
      @agentDetailsUpdate="updateAgentDetails($event)"
      @agentSignUpModalClose="agentSignUpModalClose"
    />
    <div class="dashboard-wrapper">
      <div class="dashboard-help">
        <div class="container">
          <div class="container">
            <h3 data-test="newAgentHeading"
																id="newAgentHeading"> Agent Dashboard</h3>
          </div>
        </div>
        <hr>
      </div>
      <div class="container">
        <div class="dashboard-card-warpper">
          <!-- 1 -->
          <div class="dashboard-card">
            <!-- tag -->
            <div class="dashbord-tag success"
																	data-test="newAgentRequestStatus"
																	id="newAgentRequestStatus">
              <!-- Verification failed -->
              {{agentDetails.request_status}}
            </div>
            <!-- tag -->
            <div class="card-details">
              <p data-test="newAgentName"
																	id="newAgentName">
                Name:
                <span data-test="newAgentNameSpan"
																						id="newAgentNameSpan">
                  {{agentDetails.firstname+' '+agentDetails.lastname}}
                </span>
              </p>
              <p data-test="newAgentAddress"
																	id="newAgentAddress">
                Address:
                <span data-test="newAgentAddressSpan"
																						id="newAgentAddressSpan">
                  {{agentDetails.address_line1}} {{agentDetails.address_line2}}
                </span>
              </p>
              <p data-test="newAgentPhone"
																	id="newAgentPhone">
                Phone:
                <span data-test="newAgentPhoneSpan"
																						id="newAgentPhoneSpan">{{agentDetails.phone_number}}</span>
              </p>
              <p data-test="newAgentEmail"
																	id="newAgentEmail">
                Email:
                <span data-test="newAgentEmailSpan"
																						id="newAgentEmailSpan">{{agentDetails.email}}</span>
              </p>
            </div>
            <!-- action -->
            <div class="card-actions">
              <a
                type="button"
                class="btn btn-primary"
                @click.prevent="editAgentDetails"
																data-test="newAgentEditLink"
																id="newAgentEditLink"
              >
                Edit
              </a>
              <a
                type="button"
                class="btn btn-primary"
                @click.prevent="viewAgentDetails"
																data-test="newAgentViewLink"
																id="newAgentViewLink"
              >
                View
              </a>
            </div>
          </div>
          <div class="horizontal-line"></div>
          <!--tab 2-->
          <div class="dashboard-card">
            <div class="text-center pt-4">
													<span class="h6" data-test="newAgentCodeSpan"
																			id="newAgentCodeSpan">
														Your Agent Code</span></div>
            <div class="card-actions m-auto">
              <div class="btn btn-success" data-test="newAgentCode"
																			id="newAgentCode">
                {{agentDetails.agent_code}}
              </div>
            </div>
            <!--<div class="card-actions ">-->
            <!--<br>-->

            <!--</div>-->
          </div>
          <div class="horizontal-line"></div>
          <introduce-vendor-card @vendorReferred="getReferredVendors"/>
        </div>
      </div>
    </div>
    <div
      class="container pt-4"
      v-if="vendorsReturned.length>0"
    >
      <div class="container pt-4 pb-5" v-if="vendorsReturned.length>0">
        <div class="col-12 h2" data-test="newAgentVendorsRecommended"
													id="newAgentVendorsRecommended">Vendors Recommended</div>
        <div class="row">
          <vendor-card
            class="col-md-3 col-12 m-1"
            v-for="(vendor, index) in vendorsReturned"
            :vendorData="vendor"
            :key="index"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable  no-console  */
import { mapGetters } from 'vuex'
import { agentApis } from '@/services/ApiServices/agentApis'
import AgentSignUpModal from '../modals/AgentSignUpModal'
import IntroduceVendorCard from '../introduceVendor/IntroduceVendorCard'
import VendorCard from '../introduceVendor/introducedVendors/VendorCard'

export default {
	name: 'AgentDashBoard',
	components: {
		VendorCard,
		IntroduceVendorCard,
		AgentSignUpModal
	},

	data () {
		return {
			agentDetails: '',
			disableFormFields: false,
			vendorsReturned: ''
		}
	},
	computed: {
		...mapGetters('vendor', ['getStatusData'])
	},
	beforeMount () {
		this.getAgentDetails()
		this.getReferredVendors()
	},
	methods: {
		editAgentDetails () {
			$('#AgentSignUpModal').modal('show')
			this.disableFormFields = false
		},
		viewAgentDetails () {
			$('#AgentSignUpModal').modal('show')
			this.disableFormFields = true
		},
		agentSignUpModalClose () {
			this.getAgentDetails()
			$('#AgentSignUpModal').modal('hide')
		},
		async getAgentDetails () {
			try {
				this.agentDetails = await agentApis.getAgentDetails()
			} catch (err) {
				console.error('err:', err)
			}
		},
		async updateAgentDetails (agentDetails) {
			try {
				this.agentDetails = await agentApis.updateAgentDetails(agentDetails)
			} catch (err) {
				console.error('err:', err)
			}
		},
		async getReferredVendors () {
			try {
				this.vendorsReturned = await agentApis.getReferredVendors()
			} catch (err) {
				console.error('err:', err)
			}
		}
	},
	beforeRouteLeave (to, from, next) {
		const res = confirm('Leaving agent page will log you out.')
		if (res === true) {
			next()
		} else {
			next(from.path)
		}
	}
}
</script>
